import { createAction, props } from "@ngrx/store";
import { Account, BillingTransaction } from "../../core/models/account";

export const clearAccounts = createAction("[Accounts] Clear Accounts");

export const setAccounts = createAction(
  "[Accounts] Set Accounts",
  props<{
    accounts: Account[];
  }>()
);

export const updateDueInfo = createAction(
  "[Accounts] Update Due Info",
  props<{
    accountNumber: string;
    balance: string;
    dueDate: string;
    dueDay: string;
    minimumDue: string;
    autoPay: string;
    transactions: BillingTransaction[];
  }>()
);
